import SectionPage from '../components/SectionPage';

export default function Medios() {
  return (
    <SectionPage
      title="Medios"
      intro="Notas y publicaciones destacadas del archivo público de Recycla."
      sections={[
        {
          title: 'Destacadas',
          id: 'destacadas',
          body: <p>Coberturas sobre campañas de reciclaje, economía circular e innovación verde.</p>,
        },
      ]}
    />
  );
}
